<template lang="pug">
    layout(:page="'auth'")
        template(slot="title")

            // Title
            title-component(:title="$t('auth.forgotPassword.title')" type="h1")

            // Message
            div(v-html="$t('auth.forgotPassword.message')")

        // Forgot password form
        forgot-form
</template>

<script>
    import ForgotPasswordForm from './ForgotPasswordForm';
    import Layout from '../Layout';
    import Title from '~components/Title';

    export default {
        components: {
            ForgotForm: ForgotPasswordForm,
            Layout,
            TitleComponent: Title
        }
    };
</script>
